import React, { useState, useEffect } from 'react';
import { createTheme, ThemeProvider, Button, SvgIcon } from '@material-ui/core';
import { Form, Col, Row, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import InputTheme from '../Quoters/Common/Helpers/InputTheme';

import HeroImage from '../LandingPages/HeroImage/HeroImage';
import { TextInput, SelectInput, StyledRadioInput } from '../Helpers/Inputs';
import { InputMaskDate } from '../Helpers/Formatters';
import { object, string, date } from '../Helpers/Validators/customValidators';
import { getBasicInfo, setBasicInfo } from '../../sessionStorage';

import About from './About/About';
import GeneralInformation from './GeneralInformation/GeneralInformation';
import Marketing from './Marketing/Marketing';

import States from '../Helpers/Lists/States';
import MaleIcon from '../../icons/male.svg';
import FemaleIcon from '../../icons/female.svg';
import ShieldCheckmarkIcon from '../../icons/shield-checkmark.svg'
import DeathBenefitIcon from '../../icons/deathBenefit.svg'
import CalendarScheduleIcon from '../../icons/calendarSchedule.svg';

import './Landing.scss';
import CallToAction from './CallToAction/CallToAction';
import { sub } from 'date-fns';
import { emptyStringToUndefined } from '../Helpers/Formatters/EmptyStringToUndefined';

export default function Landing(props) {

  const { register, errors, handleSubmit,triggerValidation,setValue } = useForm({
    validationSchema: Landing.ValidationSchema(),
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
  });

  const prefill = props.location && props.location.search && props.location.search.toLowerCase().includes('prefill');
  const [formState, setFormState] = useState(Landing.DefaultFormState(prefill, getBasicInfo()));

  const handleValueChange = (field, value) => {
    setValue(field, value);
    setFormState({ ...formState, [field]: value });
  };
  
  const handleGenderValueChange = (field, value) => {
    handleValueChange(field, value);
    triggerValidation(field);
  }

  const onSubmit = (s) => {
    setBasicInfo({ ...getBasicInfo(), ...formState });
    props.history.push('/policy-review/existing-insurance')
  }

  useEffect(() => {
    // manually register fields for validation that don't play nice with react-hook-form register
    register({ name: 'gender' });
    setValue('gender', formState.gender);
  }, [register]);

  const scrollToTop = () => {
    window.scroll(0, 0);
  }

  useEffect(() => {
    scrollToTop();
  }, []);

  const heroImageUrl = "/product-landing/revi/hero-image.jpg";
  const heroImageTabletUrl = '/product-landing/revi/hero-image.jpg';
  const heroImageMobileUrl = '/product-landing/revi/hero-small.jpg';

  const form = <ThemeProvider theme={(theme) => createTheme({
    ...theme,
    ...InputTheme(),
  })}>
    <div className="basic-info-about-me d-flex justify-content-center">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="justify-content-center" >
          <Col lg={12}>

            <StyledRadioInput
              name="gender"
              id="gender"
              value={formState.gender}
              options={[{ value: "F", label: "Female", icon: <FemaleIcon /> }, { value: "M", label: "Male", icon: <MaleIcon /> }]}
              onChange={e => handleGenderValueChange('gender', e)}
              errors={errors.gender}
              isBlankIcon={true}
              isBlankCheckMark={true}
            />

            <Form.Group>
              <TextInput
                name="birthdate"
                id="birthdate"
                label="Date of Birth"
                value={formState.birthdate}
                errors={errors && errors.birthdate}
                inputRef={register}
                onChange={(e) => handleValueChange('birthdate', e.target.value)}
                InputProps={{
                  inputComponent: InputMaskDate,
                }}
              />
            </Form.Group>

            <Form.Group>
              <SelectInput
                name="state"
                id="state"
                value={formState.state}
                onChange={(e) => handleValueChange('state', e.target.value)}
                label="State"
                inputRef={register}
                selectOptions={States()}
                errors={errors && errors.state}
              />
            </Form.Group>

          </Col>
        </Row>
        <Row className="mt-0">

          <Col className="text-right pb-0">
            <Button variant="contained" size="medium" color="primary" type="submit" fullWidth>
              <ShieldCheckmarkIcon className="button-icon" /> NEXT
            </Button>
          </Col>

        </Row>
      </Form>
    </div>
  </ThemeProvider>

  return (
    <Container fluid>

      <HeroImage
        title={'Life Insurance Policy Review'}
        subtitle={'It May Be Time for a Check Up'}
        smallHero={true}
        heroImageUrl={heroImageUrl}
        heroImageTabletUrl={heroImageTabletUrl}
        heroImageMobileUrl={heroImageMobileUrl}
        form={form}
      />

      <About />

      <GeneralInformation />

      <CallToAction
        title="Get your policy review today"
        actions={<Button color="primary" onClick={scrollToTop}>SCHEDULE A REVIEW</Button>} />

      <Marketing />

      <CallToAction
        title="Get a personalized insurance quote today"
        subtitle="A great rate is just a few clicks away."
        actions={
          <div className="button-container d-flex">
            <Button className="button-block" color="primary" href="/landing/term">
              <div className="icon"><SvgIcon component={CalendarScheduleIcon} color='primary' /></div>TERM LIFE<br />INSURANCE</Button>
            <Button className="button-block" color="primary" href="/landing/permanent">
              <div className="icon"><SvgIcon component={DeathBenefitIcon} color='primary' /></div>PERMANENT<br />LIFE INSURANCE</Button>
          </div>
        } />

    </Container>
  )

}

Landing.ValidationSchema = () => {
  return object().shape({
    gender: string().required('Gender is required.'),
    birthdate: date()
    .typeError('Invalid date.')
    .max(sub(new Date(), { days: 0 }), 'Future Date is not allowed.')
    .required('Birthdate is required.'),
    state: string().required('State is required.'),
  })
};

Landing.DefaultFormState = (prefill = false, basicInfo) => {
  return {
    gender: prefill ? 'M' : (basicInfo && basicInfo.gender || ''),
    birthdate: prefill ? '10/10/1990' : (basicInfo && basicInfo.birthdate || ''),
    state: prefill ? 'ID' : (basicInfo && basicInfo.state || ''),
  };
};


// WEBPACK FOOTER //
// ./src/components/PolicyReview/Landing.js